module.exports = __webpack_public_path__ + "src/images/Direct-Health-Banner-White.png";